import React, { useState } from 'react';
import { Building2, User } from 'lucide-react';
import KYBForm from '../../components/auth/KYBForm';

const RegisterPage = () => {
  const [step] = useState('kyb'); // Only KYB for institutional users
  const [userType] = useState('corporate');

  const handleBack = () => {
    // Navigate back to login since we removed the type selection
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 to-primary-800 relative">
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        <div className="relative z-10 flex flex-col justify-center px-12 text-white">
          <div className="mb-8">
            <h1 className="text-4xl font-bold mb-4 text-white">
              Join TBPP Platform
            </h1>
            <p className="text-xl text-primary-100">
              Complete your institutional registration with our secure verification process
            </p>
          </div>
          
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center">
                <Building2 className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-semibold mb-1 text-white">Institutional Registration</h3>
                <p className="text-primary-100">
                  Comprehensive verification for institutional investors and custodians
                </p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center">
                <User className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-semibold mb-1 text-white">Role Selection</h3>
                <p className="text-primary-100">
                  Choose between Investor (Direct) and Custodian roles
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Registration Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-2xl">
          {step === 'kyb' && (
            <div>
              <div className="mb-6">
                <h2 className="text-2xl font-bold text-secondary-900">
                  Institutional Registration
                </h2>
                <p className="text-secondary-600">
                  Start by selecting your role, then complete your institutional information
                </p>
              </div>
              <KYBForm onBack={handleBack} />
            </div>
          )}

          {/* Login Link */}
          <div className="mt-8 text-center">
            <p className="text-secondary-600">
              Already have an account?{' '}
              <a href="/login" className="text-primary-500 hover:text-primary-600 font-medium">
                Sign In
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage; 